import { render } from "./serviceRecord.vue?vue&type=template&id=437f2b1e&scoped=true"
import script from "./serviceRecord.vue?vue&type=script&lang=js"
export * from "./serviceRecord.vue?vue&type=script&lang=js"

import "./serviceRecord.vue?vue&type=style&index=0&id=437f2b1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-437f2b1e"

export default script